import React from 'react'
import { Row, Col, Spin } from 'antd'

function ReactBeatLoader() {
	return (
		<Row justify='center' align='middle' style={{ minHeight: '100vh' }}>
			<Col>
				<Spin size='large' />
			</Col>
		</Row>
	)
}

export default ReactBeatLoader
